import {saveWallet} from './helper';
import {encrypt} from '../../helpers/crypto'
const WavesAPI = require('@waves/waves-api');

export function setWAVWallet(walletKey,password,done){
  return function(dispatch,getState) {
    try {
      const Waves = WavesAPI.create(WavesAPI.MAINNET_CONFIG);
      const seed = Waves.Seed.fromExistingPhrase(walletKey);
      let address = seed.address;
      let enc = encrypt(walletKey,password);
      saveWallet(getState(),'wav',address,enc,dispatch)
      done(null)
    }
    catch(err){
      done(err);
    }
  }
}

export function getWAVAddress(walletKey){
  return function(dispatch,getState) {
    try {
      const Waves = WavesAPI.create(WavesAPI.MAINNET_CONFIG);
      const seed = Waves.Seed.fromExistingPhrase(walletKey);
      let address = seed.address;
      return address;
    }
    catch(err){
      return;
    }
  }
}
